import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

import { WorkOSAuthProvider } from "./auth/workosAuth";
import { PostHogProvider } from 'posthog-js/react';

// PostHog options
const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  defaults: '2025-05-24',
};

// Conditionally wrap with PostHogProvider only if API key is set
const AppWithProviders = process.env.REACT_APP_POSTHOG_KEY ? (
  <PostHogProvider
    apiKey={process.env.REACT_APP_POSTHOG_KEY}
    options={posthogOptions}
  >
    <WorkOSAuthProvider>
      <App />
    </WorkOSAuthProvider>
  </PostHogProvider>
) : (
  <WorkOSAuthProvider>
    <App />
  </WorkOSAuthProvider>
);

ReactDOM.render(
  <BrowserRouter>
    {AppWithProviders}
  </BrowserRouter>,
  document.getElementById("root")
);
